import { GotoLogger } from '@getgo/goto-logger'
import type { Logger } from '@getgo/goto-logger'

let _logger: Logger | null = null

/**
 * Returns the scoped logger for the goto-gallery application.
 *
 * The instance is created lazily on first call using `GotoLogger.createRoot`
 * and a `'goto-gallery'` child namespace, then reused for all subsequent
 * calls. This mirrors the pattern used in shell-core's `getShellLogger()`.
 *
 * @returns The application-scoped {@link Logger} instance.
 */
export function getLogger(): Logger {
  if (!_logger) {
    _logger = GotoLogger.createRoot({ mincategory: 'debug' }).create('goto-gallery')
  }
  return _logger
}
